import { render, staticRenderFns } from "./BackupChart.vue?vue&type=template&id=f6c2f1c0"
import script from "./BackupChart.vue?vue&type=script&lang=js"
export * from "./BackupChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports